<template>
  <div>
    <v-row align="center" class="pa-4 mb-2">
      <v-card-title>Белый список телефонных номеров</v-card-title>
      <div>
        <BaseTextField
          v-model="phoneSearch"
          type-input="string"
          :is-button="false"
          label="Номер телефона"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="dialogNew = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-new-box</v-icon>
          </v-btn>
        </template>
        <span>Создать номер</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="popupImport = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-application-import</v-icon>
          </v-btn>
        </template>
        <span>Импорт номеров</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="handleExport"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="loadWhitePhoneNumbers"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>

    <!-- Диалог создания/редактирования -->
    <v-dialog v-model="dialogNew" max-width="650" content-class="dialog-border-radius">
      <create-white-phone-number
        :active.sync="dialogNew"
        :editing-item="editingItem"
        icon="mdi-phone-check"
        :message="editingItem ? 'Редактировать номер' : 'Новый номер в белом списке'"
        @save="handleSave"
        @close="closeDialog"
      />
    </v-dialog>

    <!-- Диалог импорта -->
    <v-dialog v-model="popupImport" max-width="500" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="card-header" style="box-shadow: none;">
          <span class="text-h5">Импорт белого списка</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="popupImport = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-col cols="11" class="py-0 mt-4">
            <v-file-input
              v-model="importFile"
              accept=".csv"
              outlined
              dense
              flat
              label="Файл с номерами"
              :rules="[value => !!value || 'Обязательное поле']"
              append-icon="mdi-information-outline"
              @click:append="infoImportUpload = !infoImportUpload"
            ></v-file-input>
            <v-col
              v-if="!infoImportUpload"
              class="ml-5 pt-0"
            >
              <p>Формат файла: CSV</p>
              <p>Кодировка файла должна быть: Юникод (UTF-8)</p>
              <p>Формат: телефон, имя (необязательно), id домофона (необязательно), номер кв (необязательно)</p>
            </v-col>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              large
              color="success"
              class="text-none"
              dense
              :disabled="importFile === null"
              @click.prevent="handleImport"
            >
              Импортировать
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Результат импорта -->
    <v-dialog v-model="resultDialog" max-width="700px" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Результат <span style="color: #388E3C; padding-left: 5px; padding-right: 5px">{{ action }}</span> номеров
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Шлагбаум: {{ barrier.address || `id: ${barrier.id}` }}</v-list-item-title>
                <v-list-item-subtitle :class="results.success ? 'text-success' : 'text-error'">
                  <div v-if="results.message">
                    {{ results.message }}
                  </div>
                  <div v-else-if="results.error">
                    {{ results.error }}
                  </div>
                  <div v-else>
                    {{ results.success ? 'Успешно' : 'Ошибка.' }}
                  </div>
                </v-list-item-subtitle>
                <div v-if="results.importedCount !== undefined || results.skippedCount !== undefined" class="mt-2">
                  <div v-if="results.importedCount !== undefined">
                    <strong>Импортировано:</strong> {{ results.importedCount }}
                  </div>
                  <div v-if="results.skippedCount !== undefined">
                    <strong>Пропущено:</strong> {{ results.skippedCount }}
                  </div>
                </div>
                <div v-if="results.errors && results.errors.length > 0" class="mt-2">
                  <div class="text-error">
                    <strong>Ошибки:</strong>
                    <ul style="margin-top: 5px; padding-left: 20px;">
                      <li v-for="(error, errorIndex) in results.errors" :key="errorIndex" style="margin-bottom: 3px;">
                        {{ error }}
                      </li>
                    </ul>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="resultDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог удаления -->
    <v-dialog v-model="showDeleteDialog" max-width="400" content-class="dialog-border-radius">
      <baseDeleteModal
        :active.sync="showDeleteDialog"
        @close="showDeleteDialog = false"
        @submit="deleteSelectedItems"
        messageTitle="Удалить номера?"
        messageText="Подтверждая, вы удалите выбранные номера из белого списка."
      />
    </v-dialog>

    <v-data-table
      class="table"
      :headers="headersTable"
      :items="filtered"
      item-key="id"
      :footer-props="{ showFirstLastPage: true }"
    >
    <template v-slot:header.is_blocked>
        Статус
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              text
              x-large
              style="cursor: default;"
              class="btn__icon pa-0 ml-4"
              width="18"
              height="18"
            >
              <v-icon size="x-large">mdi-chat-question-outline</v-icon>
            </v-btn>
          </template>
          <span>По нажатию на статус вы можете изменить состояние телефонного номера.</span>
        </v-tooltip>
      </template>
      <template v-slot:item.phone_number="{ item }">
        {{ formatPhoneNumber(item.phone_number) }}
      </template>
      <template v-slot:item.is_blocked="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary darken-1"
              text
              @click="toggleBlock(item)"
            >
              <v-icon small :color="item.is_blocked ? 'orange' : 'green'">
                mdi-checkbox-blank-circle
              </v-icon>
            </v-btn>
          </template>
          <span v-if="item.is_blocked">Заблокирован</span>
          <span v-else>Активен</span>
        </v-tooltip>
      </template>
      <template v-slot:item.valid="{ item }">
        <div v-if="item.valid_from">
          {{ formatDate(item.valid_from) }} - {{ formatDate(item.valid_until)}}
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="editItem(item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                v-bind="attrs"
                v-on="on"
                tile
                small
                class="btn__icon ml-4 mr-1"
                width="18"
                height="18"
                @click.stop="$set(dialogWarning, item.id, true)"
              >
                <v-icon size="large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
          <v-dialog v-model="dialogWarning[item.id]" max-width="400" content-class="dialog-border-radius">
            <baseDeleteModal
              :active.sync="dialogWarning[item.id]"
              @close="$set(dialogWarning, item.id, false)"
              @submit="deleteItem(item.id)"
              messageTitle="Удалить номер?"
              messageText="Подтверждая, вы удалите номер из белого списка."
            />
          </v-dialog>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import baseDeleteModal from '@/components/BaseDeleteModal';
import BaseTextField from '../../../BaseTextField';
import formatPhoneNumber from '../../../../mixins/formatPhoneNumber';
import CreateWhitePhoneNumber from './CreateWhitePhoneNumber';
import formatPhoneNumberTextField from '@/mixins/formatPhoneNumberTextField';

export default {
  name: 'WhitePhoneNumbers',
  mixins: [ruDateFormatMixin, formatPhoneNumber, formatPhoneNumberTextField],
  components: { baseDeleteModal, BaseTextField, CreateWhitePhoneNumber },
  props: {
    barrier: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      whitePhoneNumbers: [],
      selectedItems: [],
      phoneSearch: '',
      dialogNew: false,
      popupImport: false,
      showDeleteDialog: false,
      dialogWarning: {},
      importFile: null,
      infoImportUpload: false,
      editingItem: null,
      results: [],
      resultDialog: false,
      action: '',
      headersTable: [
        { text: 'Телефон', value: 'phone_number', sortable: false },
        { text: 'Имя', value: 'full_name', sortable: false },
        { text: 'Адрес', value: 'address' },
        { text: 'Квартира', value: 'apartment', sortable: false },
        { text: 'Статус', value: 'is_blocked', sortable: false },
        { text: 'Промежуток дейсвия номера', value: 'valid', sortable: false },
        { text: '', value: 'action', sortable: false, width: '100px' },
      ],
    };
  },
  created () {
    this.loadWhitePhoneNumbers();
  },
  computed: {
    filtered () {
      if (this.phoneSearch) {
        const searchNormalized = String(this.phoneSearch).replace(/\D/g, '');

        return this.whitePhoneNumbers.filter(item => {
          if (item.phone_number === null) {
            return false;
          }

          const phoneNormalized = String(item.phone_number).replace(/\D/g, '');
          const phoneFormatted = this.formatPhoneNumber(item.phone_number);

          return phoneNormalized.includes(searchNormalized) ||
            phoneFormatted.toLowerCase().includes(this.phoneSearch.toLowerCase());
        });
      } else {
        return this.whitePhoneNumbers;
      }
    },
  },
  methods: {
    ...mapActions({
      getWhitePhoneNumbers: 'Barriers/getWhitePhoneNumbers',
      createWhitePhoneNumber: 'Barriers/createWhitePhoneNumber',
      updateWhitePhoneNumber: 'Barriers/updateWhitePhoneNumber',
      deleteWhitePhoneNumber: 'Barriers/deleteWhitePhoneNumber',
      importWhitePhoneNumbers: 'Barriers/importWhitePhoneNumbers',
      exportWhitePhoneNumbers: 'Barriers/exportWhitePhoneNumbers',
    }),
    handlePhoneSearchInput (event) {
      const phoneValue = typeof event === 'string' ? event : (event.target?.value || event);
      this.phoneSearch = this.formatPhoneNumberTextField(phoneValue);
    },
    loadWhitePhoneNumbers () {
      this.getWhitePhoneNumbers({ barrierId: this.barrier.id })
        .then((response) => {
          this.whitePhoneNumbers = response.data || [];
        })
        .catch((error) => {
          console.error(error);
          this.$flash_warning('Ошибка при загрузке белого списка');
        });
    },
    closeDialog () {
      this.dialogNew = false;
      this.editingItem = null;
    },
    editItem (item) {
      this.editingItem = item;
      this.dialogNew = true;
    },
    handleSave (phoneNumber, fullName, address, apartment, validFrom, validUntil) {
      const params = {
        phone_number: phoneNumber,
        full_name: fullName,
        address: address,
        apartment: apartment,
        valid_from: validFrom,
        valid_until: validUntil,
      };

      const editingItem = this.editingItem;

      if (editingItem) {
        this.updateWhitePhoneNumber({
          barrierId: this.barrier.id,
          whitePhoneNumberId: editingItem.id,
          params,
        })
          .then(() => {
            this.$flash_success('Номер успешно обновлен');
            this.loadWhitePhoneNumbers();
            this.closeDialog();
          })
          .catch((error) => {
            this.handleError(error);
          });
      } else {
        this.createWhitePhoneNumber({
          barrierId: this.barrier.id,
          params,
        })
          .then(() => {
            this.$flash_success('Номер успешно создан');
            this.loadWhitePhoneNumbers();
            this.closeDialog();
          })
          .catch((error) => {
            this.handleError(error);
          });
      }
    },
    deleteItem (id) {
      this.deleteWhitePhoneNumber({
        barrierId: this.barrier.id,
        whitePhoneNumberId: id,
      })
        .then(() => {
          this.$flash_success('Номер успешно удален');
          this.loadWhitePhoneNumbers();
          this.$set(this.dialogWarning, id, false);
        })
        .catch((error) => {
          this.handleError(error);
          this.$set(this.dialogWarning, id, false);
        });
    },
    deleteSelectedItems () {
      const promises = this.selectedItems.map(item =>
        this.deleteWhitePhoneNumber({
          barrierId: this.barrier.id,
          whitePhoneNumberId: item.id,
        }),
      );

      Promise.all(promises)
        .then(() => {
          this.$flash_success('Номера успешно удалены');
          this.loadWhitePhoneNumbers();
          this.selectedItems = [];
          this.showDeleteDialog = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showDeleteDialog = false;
        });
    },
    toggleBlock (item) {
      const params = {
        phone_number: item.phone_number,
        full_name: item.full_name || null,
        address: item.address || null,
        apartment: item.apartment || null,
        valid_from: item.valid_from || null,
        valid_until: item.valid_until || null,
        is_blocked: !item.is_blocked,
      };

      this.updateWhitePhoneNumber({
        barrierId: this.barrier.id,
        whitePhoneNumberId: item.id,
        params,
      })
        .then(() => {
          this.$flash_success(item.is_blocked ? 'Номер разблокирован' : 'Номер заблокирован');
          this.loadWhitePhoneNumbers();
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    handleImport () {
      if (!this.importFile) {
        this.$flash_warning('Выберите файл для импорта');
        return;
      }

      const formData = new FormData();
      formData.append('csv_file', this.importFile);

      this.action = 'Импорт';

      this.importWhitePhoneNumbers({
        barrierId: this.barrier.id,
        formData,
      })
        .then((response) => {
          const hasErrors = response.errors && response.errors.length > 0;
          const importedCount = response.imported_count || 0;
          const skippedCount = response.skipped_count || 0;
          const message = response.message || '';

          this.results = {
            success: !hasErrors,
            message: message,
            importedCount: importedCount,
            skippedCount: skippedCount,
            errors: response.errors || [],
          };

          this.loadWhitePhoneNumbers();
          this.popupImport = false;
          this.importFile = null;
          this.resultDialog = true;

          if (hasErrors) {
            this.$flash_warning('Импорт завершен с ошибками. Проверьте детали результате.');
          } else {
            this.$flash_success('Номера успешно импортированы');
          }
        })
        .catch((error) => {
          this.results = {
            success: false,
            error: this.getErrorMessage(error),
          };
          this.resultDialog = true;
          this.handleError(error);
        });
    },
    handleExport () {
      this.exportWhitePhoneNumbers({ barrierId: this.barrier.id })
        .then((response) => {
          const blob = new Blob([response], { type: 'text/csv' });
          const a = document.createElement('a');
          a.download = `white-phone-numbers-barrier-${this.barrier.id}.csv`;
          a.href = URL.createObjectURL(blob);
          a.click();
          this.$flash_success('Отчёт успешно скачан');
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    handleError (error) {
      if (error.response && error.response.data) {
        if (error.response.data.errors) {
          const errors = error.response.data.errors;
          for (const field in errors) {
            errors[field].forEach(err => this.$flash_warning(`${field}: ${err}`));
          }
        } else if (error.response.data.message) {
          this.$flash_warning(error.response.data.message);
        } else {
          this.$flash_warning('Произошла ошибка');
        }
      } else {
        this.$flash_warning('Произошла ошибка');
      }
    },
    getErrorMessage (error) {
      if (error.response && error.response.data) {
        if (error.response.data.message) {
          return error.response.data.message;
        }
      }
      return 'Ошибка.';
    },
    formatDate (date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('ru-RU');
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-radius: 16px;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.card-footer {
  margin-left: 10px;
}
</style>
